import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { fetchAcceptPublicOffer } from '../../../services/joinOtaIndividual/fetchAcceptPublicOffer';
import { goToErrorStep, goToNextStep } from '../../../slices/joinOtaLegalShort';

export const acceptPublicOffer = createAsyncThunk<void, void, IThunkApi>(
  'joinOtaLegalShort/acceptPublicOffer',
  async (_params, thunkApi) => {
    const { dispatch, extra: context } = thunkApi;

    try {
      await fetchAcceptPublicOffer(context);

      dispatch(goToNextStep());
    } catch (e) {
      dispatch(
        goToErrorStep({
          logger: context.logger,
          error: 'Ошибка при подписании оферты для юр лица',
        }),
      );
    }
  },
);
